module.exports = __webpack_public_path__ + "static/media/log.cefd90b6.svg";